<template>
	<li class="nt-li pl-2">
		<div class="nt-container pr-2 py-1" @click.stop="toggleChildren">
			
			<span v-if="isExpandable">
				<span v-show="open"><i class="fas fa-caret-down" style="width: 16px;"></i></span>
				<span v-show="!open"><i class="fas fa-caret-right" style="width: 16px;"></i></span>
			</span>
			<span v-else>
				<i class="fas fa-caret-right" style="color: #999; width: 16px;"></i>
			</span>

			<span class="pr-1">{{node.title}}</span>
			
			<span v-if="showAddButton" title="Add Sub-Element" class="nt-icon p-1" @click.stop="addChild">
				<i class="fas fa-plus-square"></i>
			</span>
			<router-link v-if="node.url" :to="node.url" title="Navigate to Element" class="nt-icon p-1">
				<i class="fas fa-link"></i>
			</router-link>
			<span v-if="isExpandable" title="Expand All" class="nt-icon p-1" @click.stop="expandTree">
				<i class="fas fa-eye"></i>
			</span>

			<small v-if="node.description" class="text-muted float-right" style="max-width: 50%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{node.description}}</small>
		</div>
		<ul v-show="open" v-if="isExpandable" class="pl-3">
			<tree-node class="item" v-for="(n, index) in node.children" :key="index" :node="n" :expand-all="openAll" />
			<!--<li class="add" @click.prevent="addChild">+</li>-->
		</ul>
	</li>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import TreeNode from "@/components/utilities/TreeNode";
import Vue from 'vue';

export default {
	name: "tree-node",
	components: { TreeNode },
	props:
	{
		node: Object,
		expandAll: Boolean,
	},
	data: function()
	{
		return {
			open: false,
			openAll: false,
		};
	},
	watch:
	{
		expandAll( newVal )
		{
			if( newVal === true )
				this.expandTree( );
		}
	},
	mounted( )
	{
		if( this.expandAll )
			this.open = true;
	},
	computed: {
		isExpandable( )
		{
			return Array.isArray( this.node.children ) && this.node.children.length > 0;
		},
		showAddButton( )
		{
			return typeof this.node.addChildFunction === 'function';
		}
	},
	methods: {
		addChild( )
		{
			if( this.showAddButton )
				this.node.addChildFunction( this.node );
		},
		toggleChildren( )
		{
			if( this.isExpandable )
				this.open = !this.open;
		},
		expandTree( )
		{
			console.log( "EXPAND TREE" );
			this.open = true;
			this.openAll = true;
			this.$nextTick( (() => {
				this.openAll = false;
			}).bind(this) );
		}
	}
};
</script>
<style scoped>
.nt-li {
	list-style: none;
}
.nt-li:hover {
	background-color: rgba( 0, 0, 0, 0.04 );
}
.nt-container {
	cursor: default;
	user-select: none;
}
.nt-container:hover > .nt-icon {
	display: inline;
}
.nt-icon {
	color: rgba( 0, 0, 0, 0.4 );
	display: none;
	cursor: pointer;
}
.nt-icon:hover {
	color: #2c859e;
}
.bold {
	font-weight: bold;
}
em {
	color: #e66;
}
</style>



// WEBPACK FOOTER //
// src/components/utilities/TreeNode.vue